export const en = {
  app_name: "AutoWise",
  header: {
    categories: "Categories",
    search_placeholder: "Search {app_name}",
    zip_placeholder: "48303",
    log_in: "Log In",
    sign_up: "Free Sign Up",
    my_garage: "My Garage & Quotes",
    request_a_quote: "Request a Quote",
    service_providers: "Service Providers",
    select_vehicle: "Select Vehicle",
    user_dropdown: {
      settings: "Settings",
      notification_center: "Notification Center",
      remaining_quotes: "Available Quotes: {remaining_quote_number}",
      buy_more_quotes: "Purchase Quotes",
      quotes: "Quotes",
      contact_us: "Contact Us",
      log_out: "Log Out"
    }
  },
  footer: {
    company: "Company",
    about_blitzify: "About {app_name}",
    blitzify_blog: "{app_name} Blog",
    press_center: "Press Center",
    service: "Service",
    quote_a_service: "Quote a Service",
    find_your_quote: "Find your Quote",
    providers_by_state: "Providers by State",
    shipping_returns: "Shipping & Returns",
    knowledge_center: "Otto's Wise Guide",
    comments: "Comments",
    media_center: "Media Center",
    documents: "Documents",
    help_center: "Help Center",
    contact_us: "Contact Us",
    connect_with_us: "Connect With Us",
    rights_reserved: "©{current_year} {app_name}. All Rights Reserved.",
    terms_conditions: "Terms & Conditions",
    become_host: "Become A {app_name} Host",
    powered_by_credit: ["Powered by", "InteliChek, LLC"],
  },
  landing_page: {
    real_prices_header: "We call around so you don't have to.",
    real_prices_subheader: "Get the real information you need to ensure you're paying the right price for your car repairs and maintenance services, every time.",
    real_prices_text: "Get smart about your car. Get AutoWise.",
    free_quote: "Get Your Free Quote Now",
    what_is_blitzify: "What is {app_name}?",
    out_door_prices: "Because your quote should come from a human, not a guess.",
    out_door_prices_text: "AutoWise calls repair shops directly — no middlemen, no price ranges, no \"starting at\" prices.",
    free_account_perks: {
      title: "Free Quotes",
      text: "Get 1 free quote per month that includes prices from 4 of your local repair shops. Plus! You will get an additional 3 quotes to use anytime throughout the year.",
      button_text: "Sign Up Now",
    },
    what_is_autowise_video_prompt: "Our agents do the calling. You get the wisdom.",
    wise_guide: {
      button_text: "Otto's Wise Guide"
    },
    disrupting_auto_experience: {
      title: "Steer Clear Of Overpriced Repairs",
      text: "We eliminate the stress associated with locating an honest, reliable automotive repair shop within your budget. But that's not all...",
      button_text: "See {app_name} Features",
    },
    understands_vehicle: {
      title: "Understand Your Virtual Garage",
      text: "Every {app_name} user has their own Virtual Garage. It tracks everything related to your vehicles.",
      button_text: "Learn More",
    },
    car_specific_accessories: {
      title: "Otto's Wise Guide",
      text: [
        "Get {app_name}!",
        "Get tips, tricks, and advice on maintaining your vehicle. Because when it comes to your vehicle, knowing is far better than guessing.",
      ],
      button_text: "Request Quote",
    },
  },
  modal: {
    login: {
      title: "Log In",
      body_1: "",
      negative: "",
      positive: "",
      back: "",
      modal_body: "Please log in to your account",
      email_label: "Email Address",
      email_placeholder: "Enter Email Address",
      password_label: "Password",
      password_placeholder: "Enter Password",
      forgot_username: "Forgot Username",
      forgot_password: "Forgot/Reset Password",
      login_button: "Log in to {app_name}",
      dont_have_account: "I don't have an account",
    },
    sign_up: {
      title: "Create Account",
      body_1: "",
      negative: "",
      positive: "",
      back: "",
      credit_card_notice: "No credit card required",
      modal_body: "Create An {app_name} Account",
      first_name_label: "First Name",
      first_name_placeholder: "Enter First Name",
      last_name_label: "Last Name",
      last_name_placeholder: "Enter Last Name",
      email_label: "Email Address",
      email_placeholder: "Enter Email Address",
      password_label: "Password",
      password_placeholder: "Enter Password",
      password_confirmation_label: "Password Confirmation",
      password_confirmation_placeholder: "Confirm Password",
      terms_conditions_agree: "I agree to the Terms and Conditions",
      terms_conditions: "View Terms and Conditions",
      sign_up_button: "Sign Up for an {app_name} Account",
      have_account: "I already have an account",
      email_already_in_use: "An account with that email already exists",
      password_requirements: {
        "requirement_1": "Be 8 characters or longer",
        "requirement_2": "Contain at least 1 lowercase letter",
        "requirement_3": "Contain at least 1 uppercase letter",
        "requirement_4": "Contain at least one number",
        "requirement_5": "Contain at least one special character (!, {'@'}, #, {'$'}, %, ^, &, *, +)",
        "requirement_6": "Not contain '<', '>', ',', or blank spaces",
        "requirement_7": "Both passwords must match"
      }
    },
    terms_and_conditions: {
      title: "Terms and Conditions",
      body_1: "",
      negative: "",
      positive: "",
      back: ""
    },
    forgot_password: {
      title: "Forgot Password",
      body_1: "",
      negative: "Cancel",
      positive: "Submit",
      back: "Back",
      modal_body: "Forgot Password Assistance",
      modal_body_text: 'In order to update your password, we need to verify your identity. Enter the email address associated with your {app_name} Account.',
      email_label: "Email Address",
      email_placeholder: "Enter Email Address",
    },
    add_vehicle: {
      title: "Add Your Ride",
      body_1: "",
      negative: "Cancel",
      positive: "Save To Garage",
      back: "",
      year_label: "Year",
      year_placeholder: "Select Year",
      make_label: "Make",
      make_placeholder: "Select Make",
      model_label: "Model",
      model_placeholder: "Select Model",
      trim_label: "Trim",
      trim_placeholder: "Select Trim",
      benefits_mileage: "Benefits of Entering Mileage",
      benefits_mileage_text: "",
      mileage_label: "Enter Mileage",
      mileage_placeholder: "Enter Mileage",
      missing_option_disclaimer: [
        "Don't see your vehicle or options? Send us an email at <a href='mailto:support@getautowise.com' class='text-blue-600'>support@getautowise.com</a> and we'll get it added!"
      ]
    },
    edit_vehicle: {
      title: "Edit Vehicle",
      body_1: "",
      negative: "Cancel",
      positive: "Save Changes",
      back: "",
      year_label: "Year",
      year_placeholder: "Select Year",
      make_label: "Make",
      make_placeholder: "Select Make",
      model_label: "Model",
      model_placeholder: "Select Model",
      trim_label: "Trim",
      trim_placeholder: "Select Trim",
      benefits_mileage: "Benefits of Entering Mileage",
      benefits_mileage_text: "",
      mileage_label: "Enter Mileage",
      mileage_placeholder: "Enter Mileage",
    },
    garage_info: {
      title: "Garage Info",
      body_1: "",
      negative: "Cancel",
      positive: "Save Updates and Close",
      back: "",
      modal_body: "Update your Garage Info",
      modal_body_text: "",
      garage_name_label: "Garage Name",
      garage_name_placeholder: "Enter Garage Name",
      garage_description_label: "Garage Description",
      garage_description_placeholder: "Enter Garage Description",
    },
    vehicle_info: {
      title: "Vehicle Info",
      body_1: "",
      negative: "Cancel",
      positive: "Save Updates and Close",
      back: "",
      modal_body: "Update your Vehicle Info",
      modal_body_text: "",
      vehicle_nickname_label: "Vehicle Nickname",
      vehicle_nickname_placeholder: "Enter Vehicle Nickname",
      vehicle_description_label: "Vehicle Description",
      vehicle_description_placeholder: "Enter Vehicle Description",
      vehicle_modification_label: "Vehicle Modifications",
      vehicle_modification_placeholder: "Enter Vehicle Modifications",
    },
    drivetrain_info: {
      title: "Drivetrain Info",
      body_1: "",
      negative: "Cancel",
      positive: "Save Updates and Close",
      back: "",
      modal_body: "Update your Drivetrain Info",
      modal_body_text: "",
      config_label: "Config",
      config_placeholder: "Enter Config",
      cylinders_label: "Cylinders",
      cylinders_placeholder: "Enter Cylinders",
      displacement_label: "Displacement",
      displacement_placeholder: "Enter Displacement",
      aspiration_label: "Aspiration",
      aspiration_placeholder: "Enter Aspiration",
      fuel_type_label: "Fuel Type",
      fuel_type_placeholder: "Enter Fuel Type",
      trans_type_label: "Trans Type",
      trans_type_placeholder: "Enter Trans Type",
      trans_speed_label: "Trans Speed",
      trans_speed_placeholder: "Enter Trans Speed",
      drivetrain_label: "Drivetrain",
      drivetrain_placeholder: "Enter Drivetrain",
    },
    design_info: {
      title: "Design Info",
      body_1: "",
      negative: "Cancel",
      positive: "Save Updates and Close",
      back: "",
      modal_body: "Update your Design Info",
      modal_body_text: "",
      exterior_label: "Exterior",
      exterior_placeholder: "Enter Exterior",
      exterior_oem_label: "Exterior OEM Name",
      exterior_oem_placeholder: "Enter Exterior OEM Name",
      exterior_order_code_label: "Exterior Order Code",
      exterior_order_code_placeholder: "Enter Exterior Order Code",
      interior_label: "Interior",
      interior_placeholder: "Enter Interior",
      interior_oem_label: "Interior OEM Name",
      interior_oem_placeholder: "Enter Interior OEM Name",
      interior_order_code_label: "Interior Order Code",
      interior_order_code_placeholder: "Enter Interior Order Code",
    },
    add_address: {
      title: "Add Saved Location",
      body_1: "",
      negative: "Cancel",
      positive: "Save & Close",
      back: "",
      location_name_label: "Location Name",
      location_name_placeholder: "Example Home, Work Etc.",
      street_address_label: "Street Address",
      street_address_placeholder: "1234 Street Name",
      street_address_2_label: "Street Address 2",
      street_address_2_placeholder: "Apt, Suite",
      city_label: "City",
      city_placeholder: "City",
      state_label: "State",
      state_placeholder: "Select State",
      zip_label: "Zip",
      zip_placeholder: "Zip Code",
      country_label: "Country",
      unknown_error: "An unknown error has occurred. Please try again.",
      geocoding_error: 'We were unable to find the addresses location. Please check your address and try again.',
      validation_error: 'The following fields are required: Address, City, State, and Zip.',
    },
    edit_address: {
      title: "Edit Saved Location",
      body_1: "",
      negative: "Cancel",
      positive: "Save & Close",
      back: "",
    },
    delete_account: {
      title: "Delete AutoWise Account",
      body_1: "",
      account_closure_plea: [
        "Sorry to see you go!",
        "Before you leave, how about one free quote - on us?",
        "It only takes a minute, and it might be just what you're looking for."
      ],
      account_closure_statement: "Are you sure you want to delete your account? This action cannot be undone and will result in the permanent loss of all your data.",
      post_incentive_gratitude: [
        "Thanks for reconsidering! Your free quote has been added to your account!"
      ],
      back_button: "Back to AutoWise",
      negative: "",
      positive: "",
      claim_incentive: "Keep my account",
      delete_my_account: "Continue with account deletion",
      back: ""
    },
    sign_up_verification: {
      title: "Sign Up Confirmation",
      body_1: "Thank you for signing up! Please check your email to verify your account. If you do not receive anything within a few moments, please check your spam folder.",
      negative: "",
      positive: "Okay",
      back: ""
    },
    resend_verification: {
      title: "Resend Confirmation",
      body_1: "Thank you for signing up! Your email still needs to be verified before you can sign in. A verification email has been sent to your email address; check your spam folder if you can't find it.<br/><br/>Not receiving your email? Connect with us <a href='https://wiseguide.getautowise.com/contact/' target='_blank' class='text-blue-500'>here</a>",
      negative: "",
      positive: "Okay",
      back: "Back to log in",
      resend_button: "Resend Verification"
    },
    change_password_confirmation_notice: {
      title: "Forgot Password",
      body_1: "A password reset email has been sent to your email address.",
      negative: "",
      positive: "Okay",
      back: "Back to log in"
    },
    stripe_payment: {
      title: "Pay with Stripe",
      body_1: "",
      negative: "",
      positive: "",
      back: "",
      pay_confirm: "Pay",
      pay_cancel: "Nevermind",
      close_after_payment_attempt: "Close",
      post_payment_gratitude: "Thank you for your payment! We have received your payment and will process it shortly. Please check your email for the receipt.",
      failed_to_create_payment_intent: "Failed to create payment intent",
      unable_to_initialize_payment: "Unable to initialize payment. Please try again.",
      payment_form_not_loaded: "Payment form not loaded yet.",
      payment_processing: "Payment is processing. We will notify you when it's complete.",
      card_declined: "Your card was declined. Please try a different payment method.",
      payment_requires_action: "Payment requires further action. Please try again.",
      unexpected_payment_status: "Unexpected payment status: {status}"
    },
    confirm_move_to_service_history: {
      title: "Move to service history?",
      body_1: "Are you sure you want to move to service history?",
      negative: "Back",
      back: "",
      positive: "I'm sure"
    },
    confirm_clear_requested_service_provider: {
      title: "Remove Service Provider?",
      body_1: "Are you sure you want to remove this service provider?",
      negative: "Back",
      back: "",
      positive: "I'm sure"
    }
  },
  settings: {
    personal_information: "Personal Information",
    account_settings: "Account Settings",
    manage_payments: "Manage Payments",
    saved_locations: "Saved Locations",
    my_reminders: "My Reminders",
    policies: "Policies",
    notification_settings: "Preferences",
    billing: "Billing",
    quote_history: {
      name: "Quote History",
      // filter: "Month - {month}",
      month_dropdown: "Filter: {filter}",
      last_30_days: "Last 30 Days",
      last_6_months: "Last 6 Months",
      all_time: "All Time",
      source_system: "AutoWise Quote Credit",
      source_monthly_top_up: "System Adjustment",
      source_yearly_top_up: "System Adjustment",
      source_request: "Request a Quote",
      source_purchase: "Purchase",
      source_user_create: "New Account Quote Credit",
      source_retention_deal: "AutoWise Quote Credit",
      source_refund: "AutoWise Quote Credit",
      source_unknown: "System Adjustment",
      no_transactions_found: "No transactions found",
      no_transactions_yet: "You haven't made any quote transactions yet."
    },
    account_settings_section: {
      title: "Account Settings",
      email_label: "Email",
      email_placeholder: "Enter Email...",
      first_name_label: "First Name",
      first_name_placeholder: "Enter First Name...",
      last_name_label: "Last Name",
      last_name_placeholder: "Enter Last Name...",
      birthday_label: "Birthday (Optional)",
      phone_number_label: "Phone Number (Optional)",
      phone_number_placeholder: "Enter Phone Number...",
      delete_account_button: "Delete Account",
      add_avatar_button: "Add an Avatar",
      change_your_password: "Change Your Password",
      current_password_label: "Current Password",
      current_password_placeholder: "Enter Current Password...",
      new_password_label: "New Password",
      new_password_placeholder: "Enter New Password...",
      confirm_password_label: "Retype New Password",
      confirm_password_placeholder: "Confirm New Password...",
      forgot_password: "Forgot Your Password",
      save_changes_button: "Save Changes",
      cancel_button: "Cancel",
      forgot_your_password: "Forgot Your Password",
      password_update_success: "Password successfully updated!",
      password_update_failed: "Password failed to update!",
      birthday_month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      birthday_placeholder: {
        month: "Month",
        day_of_month: "Day"
      },
      save_success_message: "Settings successfully updated!",
      subtitle: "Manage your personal information and account preferences",
      profile_information: "Profile Information",
      update_personal_details: "Update your personal details and profile picture",
      click_upload_picture: "Click the + button to upload a new profile picture",
      change_password: "Change Password",
      update_password_secure: "Update your password to keep your account secure",
      danger_zone: "Danger Zone",
      irreversible_actions: "Irreversible and destructive actions",
      delete_account: "Delete Account",
      delete_account_warning: "Permanently delete your account and all associated data. This action cannot be undone.",
      profile_picture_updated: "Profile picture updated successfully!",
      profile_picture_failed: "Failed to upload profile picture",
      password_updated_success: "Password updated successfully!",
      account_updated_success: "Account information updated successfully!",
      account_update_failed: "Failed to update account information"
    },
    saved_location_section: {
      primary_address: "Primary Address",
      add_location: "Add Location",
      make_primary: "Make Primary",
      edit: "Edit",
      delete: "Delete",
      manage_addresses: "Manage your frequently used addresses",
      we_found_location: "We found your location!",
      save: "Save",
      dismiss: "Dismiss",
      saved_locations: "Saved Locations",
      frequently_used_addresses: "Your frequently used addresses",
      refreshing: "Refreshing...",
      refresh: "Refresh",
      no_saved_locations: "No saved locations yet",
      add_first_location: "Add your first location to get started",
      add_first_location_button: "Add Your First Location",
      unnamed_location: "Unnamed Location",
      primary: "Primary",
      location_saved_success: "Location saved successfully!"
    },
    notification_settings_section: {
      name: 'Notification Settings',
      email_notifications: 'Email Notifications',

      quote_notifications: 'Quote Updates',
      quote_notifications_subtext: 'Receive email notifications when the status of your quotes changes — from submitted to delayed, or completed — so you\'re always up to date.',

      vehicle_information_notifications: 'Vehicle Information Updates',
      vehicle_information_notifications_subtext: 'Receive email notifications when vehicle information is updated — including added or removed vehicles, mileage changes, or completed services — so you\'re always informed.',

      account_summary_notifications: 'Account Summary Updates',
      account_summary_notifications_subtext: 'Get notified when changes are made to your account details — such as updated email addresses, contact info, or other personal information — to help you stay on top of your profile.',

      website_notifications: 'Website Notifications',
      website_notifications_subtext: 'Enable in-site alerts for updates, and activity.',

      website_popups: "Website Popups",
      
      quote_returned_notifications: 'Quote Returned',
      quote_returned_notifications_subtext: 'Get notified when your requested quote has been completed and is ready for review.',
      
      quote_expiring_notifications: 'Quote Expiring Soon',
      quote_expiring_notifications_subtext: 'Receive alerts when your quotes are about to expire so you don\'t miss out on pricing.',
      
      quote_delayed_notifications: 'Quote Delayed',
      quote_delayed_notifications_subtext: 'Be informed if there are any delays in processing your quote request.',

      disable_all_notifications: 'Turn off all communication',
      enable_all_notifications: 'Turn on communication',
      enable_all_notifications_subtext: 'Enable email notifications from this website. If this is off, you won\'t receive any emails — including quote updates, vehicle info, or account changes. Unsubscribing from any email will turn this off.',

      settings_saved: 'Settings Saved.',
      website_popups_enabled: 'Website popups enabled!'
    },
    orders: {
      name: "Quote Purchasing",
      title: "Compare & Save Packages",
      buy_button: "Get started",
      payment_card_padlock: "🔒 Secure Payment Processing",
      security_affirmation_title: "Secure Payment Processing",
      we_use_stripe_text: "We use",
      we_use_stripe_text_2: "to process all payments. Your credit card information is encrypted and securely handled by Stripe. AutoWise does not store or have access to your full credit card details at any time.",
      packages: {
        three_quotes_title: "3 Quotes",
        three_quotes_description: "Ideal if you've got a few upcoming repairs or maintenance items in mind.",
        five_quotes_title: "5 Quotes",
        five_quotes_description: "Planning ahead? Get quotes for multiple services - when and where you need them.",
        one_time_purchase: "one time purchase"
      }
    }
  },
  request_a_quote: {
    vehicle: "Vehicle",
    service: "Select a service below to get your pricing quotes",
    location: "Location",
    select_vehicle: "Select Vehicle",
    select_service: "Select Service",
    select_location: "Select Location",
    next: "Next",
    back: "Back",
    submit: "Request Your Quote",
    complete_quote: "Complete Your Quote",
    go_to_quote: "Go To Quote",
    buy_more_quotes_link: "Purchase more quotes here",
    buy_more_quotes_nag_tooltip: "You've reached your quote limit. To keep comparing shops and saving money, purchase additional quotes.",
    vehicle_section: {
      title: "Quote Service for {vehicle_name}",
      subtext: [
        "We know that your car is special.",
        "Get quotes customized just for your ride's year, make, and model.",
        "Pick your vehicle below or add an additional vehicle to your garage.",
      ],
      change_vehicle: "Change Vehicle"
    },
    service_section: {
      options_label: "{option} Options",
      choices_label: "{choice} Choices",
      select_from_history: "Select From Service History",
      service_categories_label: "Service Categories",
      service_category_placeholder: "Select Service",
      option_placeholder: "Select Option",
      choice_placeholder: "Select Choice",
      add_service: "Add Another Service",
      add_option_set: "Add Another Option Set",
      remove_service: "Remove Service",
      choose_service_type: "Choose Service Type",
      clear: "Clear",
      remove: "Remove",
    },
    location_section: {
      title: "Service Location for {vehicle_name}",
      subtext: [
        "Don't add a long commute to a car repair. By sharing your location, AutoWise matches you with nearby repair shops who can offer competitive quotes based on your area.",
        "Change your location below.",
      ],
      get_my_quote: "Get My Quote",
      quote_radius: "Quote Radius (Miles)",
      failed_to_retrieve_location: "We were unable to retrieve your location at this time. Please check that location permissions are enabled and try again.",
      location_permission_help: "You can still select a saved address below or add a new location to continue.",
      quote_disclaimer: "*{app_name} is Only Available in the Continental United States",
      choose_location: "Choose Location",
      saved_address: "Saved Address",
      selected: "Selected",
      use_location: "Use Location",
      use_my_location: "Use My Location",
      detected_location: "Detected location",
      auto_detect_location: "Automatically detect your current location",
      add_new_location: "Add New Location",
      please_select_location: "Please select your location",
      map_will_appear_after_selection: "Map will appear after you choose a location",
      select_location_to_view_map: "Select a location above to view the map",
      map_legend: "Blue pin: Service provider location • Orange pin: Your location",
      loading_map: "Loading map...",
      location_dropdown: {
        select_location_placeholder: "Select Location",
        your_location: "Your Location",
        other_location: "Other Location",
        search_placeholder: "City, State or Zip",
        saved_locations: "Saved Locations",
        no_saved_locations: "No Locations Saved",
        user_location_error: "Cannot get your location",
      }
    },
    success_section: {
      title: "Quote Request Submitted Successfully",
      subtext: [
        "Put your feet up...",
        "We will take the wheel from here!",
        "AutoWise will alert you as soon as your quotes are ready for review.",
        "We aim to have your quote finished within <span class=\"font-bold\">20 minutes</span>. In some cases, it may take a little longer, since our agents make <span class=\"font-bold\">real phone calls</span> to local service providers to get live price quotes on the service you requested. This is what makes <span class=\"font-bold\">AutoWise the most reliable source of pricing information available!</span>",
        "Your quote should be ready within the hour. Please check your email for updates."
      ]
    },
    quote_disclaimer_dropdown: 'Disclaimer +',
    requested_service_provider: "Requested Service Provider:",
    quote_disclaimer: [
      'The service pricing information provided by AutoWise is obtained through direct phone interactions conducted by our trained agents with auto repair facilities. During these calls, agents request quotes on specific vehicle and service scenarios and confirm whether the quoted prices include applicable taxes and shop fees.',
      'While the prices collected reflect real quotes, they may also be used to generate estimates for vehicles with similar specifications. As such, the price shown may not have been obtained for the exact vehicle you requested but is based on a comparable make, model, and configuration to maintain accuracy and relevance.',
      'We strive to ensure all pricing is accurate and current at the time of collection. However, prices are subject to change at the discretion of each auto repair facility. AutoWise cannot guarantee that the prices displayed will be honored by the listed facilities.',
      'It is important to note that auto repair facilities typically provide only estimates over the phone. Final pricing may vary based on an in-person inspection of the vehicle, which can uncover additional service needs or complexities not apparent during the call.',
      'We recommend confirming current pricing, fees, and inclusions directly with the auto repair facility before scheduling any service.'
    ]
  },
  my_garage: {
    my_garage: "My Garage & Quotes",
    all_quotes: "All Quotes",
    select_vehicle: "Select Vehicle",
    add_a_vehicle: "Add Your Ride",
    garage_full: "Garage full",
    unassigned_vehicle: "",
    unassigned_vehicle_text: "Create a Vehicle for the Best {app_name} Experience",
    add_vehicle: "Add Your Ride",
    mileage_as_of: "My Mileage as of {date}",
    miles: "Miles",
    vehicle_profile: "Vehicle Profile",
    service: "Service Quote History",
    quote: "Quote",
    vehicle_profile_progress: "Vehicle Profile Progress",
    garage_info: "Garage Info",
    vehicle_info: "Vehicle Info",
    owner_info: "Owner Info",
    edit: "Edit",
    update_mileage: "Update Mileage",
    edit_vehicle: "Edit Vehicle",
    hide_vehicle: "Hide Vehicle",
    remove_from_garage: "Remove from Garage",
    update: "Update",
    your_current_quotes: "Your Current Quotes",
    your_other_quotes: "Your Other Vehicles Quotes",
    your_recommended_services: "Your Recommended Services",
    your_service_history: "Your Service History",
    view_all: "View All",
    add_completed_service: "Add a Completed Service",
    loading: "Loading",
    quote_card: {
      requested: "Requested {date}",
      recorded: "Recorded {date}",
      expires: "Expires: {date}",
      move_to_service: "Move to Service History",
      completed: `Completed: {date}`,
      cancelled: `Cancelled`,
      incomplete: `Incomplete`
    },
    no_mileage: "No Mileage Listed",
    garage_info_section: {
      garage_info: "My Garage Info",
      garage_name: "My Garage Name",
      garage_description: "Enter a brief description about your Garage and the cars it contains."
    },
    vehicle_info_section: {
      vehicle_info: "Vehicle Info",
      vehicle_nickname: "Vehicle Nickname",
      vehicle_nickname_placeholder: "Give your vehicle a nickname.",
      vehicle_year: "Year",
      vehicle_make: "Make",
      vehicle_model: "Model",
      vehicle_description: "Vehicle Description",
      vehicle_description_placeholder: "Tell us a little about your vehicle.",
      vehicle_modifications: "Vehicle Modifications",
      vehicle_modifications_placeholder: "Tell us a little about how you've customized your garage.",
      vehicle_image: "Vehicle Image",
      vehicle_image_upload: "Upload Vehicle Image",
    },
    vehicle_specs_section: {
      vehicle_specs: "Vehicle Specifications",
      oem_spec: "Original Manufacturer Specifications",
      vehicle_identification: {
        vehicle_identification: "Vehicle Identification",
        year: "Year",
        make: "Make",
        model: "Model",
        trim: "Trim",
        body_type: "Body Type",
        vehicle_type: "Vehicle Type",
        doors: "Doors",
        msrp: "MSRP",
      },
      specifications: {
        specifications: "Specifications",
        length: "Length",
        width: "Width",
        height: "Height",
        wheel_base: "Wheel Base",
        tank: "Tank",
        curb_wt: "Curb Wt",
        wheel_diameter: "Wheel Dia",
        rr_leg_room: "Rr Leg Room",
      },
      drivetrain: {
        drivetrain: "Drivetrain",
        config: "Config",
        cylinders: "Cylinders",
        displacement: "Displacement",
        aspiration: "Aspiration",
        fuel_type: "Fuel Type",
        trans_type: "Trans Type",
        trans_speed: "Trans Speed",
      },
      design: {
        design: "Design",
        exterior: "Exterior",
        interior: "Interior",
        oem_name: "OEM Name",
        order_code: "Order Code"
      }
    },
    moving_to_service_history: "Moving to Service History...",
    quotes: {
      sort: "Sort: {direction}",
      your_quotes: "Your Quotes",
      your_last_5_quotes: "Your Last 5 Quotes",
      requested: "Requested: {date}",
      expires: "Expires: {date}",
      add_quote: 'End of List, Quote Another Service?',

      best_price: 'Best Price',
      within: "Within: ",
      distance_to_provider: "{distance} Miles",

      service_chain_dealership: "Dealership",
      service_chain_chain: "Service Chain",
      service_chain_independent: "Independent",

      out_the_door: "Out the Door",
      tax_not_included: "Tax not Included",
      oem_parts: "OEM Parts",
      more_info: "More Info",

      call_number: "Call {phoneNumber}",

      finding_service_provider: 'Finding Service Provider',
      gathering_price: 'Gathering Price',
      quote_cancelled: 'Quote Cancelled',
      quote_expired: 'Quote Expired',
      quote_stale: 'Quote Stale',
      no_price_available: 'N/A',

      sort_date_desc: 'Date (Newest)',
      sort_date_asc: 'Date (Oldest)',
      sort_price_desc: 'Price (Highest)',
      sort_price_asc: 'Price (Lowest)',
      sort_distance_nearest: 'Distance (Nearest)',

      disclaimer_blurb: "AutoWise gathers service pricing by calling repair shops directly. Quotes are based on specific or similar vehicles and may change after inspection. Confirm current pricing with the facility before booking."
    }
  },
  service_providers: {
    search_filters: {
      filter_title: "Filter Your Results",
      autowise_only: "AutoWise Only",
      location_filter: "Location",
      your_location: "Your Location: {location}",
      other_location: "Other Location",
      search_placeholder: "City, State",
      loading: "Loading...",
      location_unavailable: "Location unavailable",
      primary: "PRIMARY",
      type_filter: "Service Provider Types",
      type_filter_description: "Filter by dealerships, chains, or independent shops",
      service_chain_dealership: "Dealership",
      service_chain_chain: "Service Chain",
      service_chain_independent: "Independent",
    },
    search_results: {
      search_service_providers: "Search Service Providers",
      closest_to_location: "Closest to {location}"
    },
    service_provider_card: {
      sponsored: "Sponsored",
      within: "Within: ",
      within_miles: "{distance} Mile | {distance} Miles",
      more_info: "More Info"
    },
    service_provider_request: {
      title: "Don't See a Shop You Know?",
      body: [
        "If you know a local repair shop that's missing from our list, we'd love to hear about it. Send us their name and location at <a class='underline' href='mailto:support@getautowise.com'>support@getautowise.com</a>, and we'll look into adding them to the AutoWise network."
      ]
    },
    service_provider_disclaimer: [
      "Some repair shops in your area may not appear in this list because they have opted out of participating in AutoWise quote comparisons."
    ],
    profile: {
      quick_quote: "Quick Quote",
      distance: "Distance: {distance} Miles",
      about_us: "About Us",
      services: "Services",
      services_disclaimer: "Please note that the services listed are not exhaustive &mdash; they include only those that have been reviewed and verified to the best of our ability.",
      description: "Description",
      related_service_providers: "Nearby Service Providers"
    },
    business_hours: {
      closes_at: "Closes at {time}",
      opens_day_at: "Opens {day} at {time}",
      closed_all_week: "Closed all week",
      times_disclaimer: "Times listed in local time",
      day_labels: {
        today: "Today",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
      day_labels_short: {
        today: "Today",
        monday: "Mon",
        tuesday: "Tue",
        wednesday: "Wed",
        thursday: "Thu",
        friday: "Fri",
        saturday: "Sat",
        sunday: "Sun",
      },
      closed: "Closed",
      open: "Open",
      open_24_hours: "Open 24 Hours"
    }
  },
  verification: {
    enter_verification_code: "Enter the verification code from your email",
    verification_code_form_placeholder: "Verification Code"
  },
  password_reset: {
    submit: "Change my password",
    requirements_blurb: "Password must:"
  },
  toast: {
    login_success: "Welcome back! You've successfully logged in.",
    logout_success: "You've been logged out successfully.",
    quote_created: "Quote request submitted successfully! We'll notify you when it's ready.",
    quote_package_purchased: "Quote package purchased successfully! Your additional quotes are now available.",
    location_refreshed: "Location updated successfully.",
    quote_completed: "Your quote for {vehicle} is ready! Check your garage to view the results.",
    quote_delayed: "Your quote for {vehicle} is taking longer than expected. We'll notify you when it's ready.",
    quote_expiring: "Your quote for {vehicle} is expiring soon. Review it before it expires!"
  },
  map: {
    loading: "Loading..."
  }
};